<sc-padding>
  <app-transport-options-panel [model]="model"></app-transport-options-panel>
</sc-padding>